import React from 'react';

export const SearchBar: React.FC<any> = (props) => {
  return (
    <div className='mfrm-search__wrapper'>
      {props.children}
    </div>
  );
};